import { render } from "./DashboardSpecialty.vue?vue&type=template&id=564748da&lang=pug"
import script from "./DashboardSpecialty.vue?vue&type=script&lang=js"
export * from "./DashboardSpecialty.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__